/**
 * @generated SignedSource<<2cb807eb3caf16d7b5160c9d2673c1af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GeneratePaymentMethodClientTokenInput = {
  brainTreeNetwork?: string | null;
  vendor?: string | null;
};
export type useBraintreeClientTokenMutation$variables = {
  input: GeneratePaymentMethodClientTokenInput;
};
export type useBraintreeClientTokenMutation$data = {
  readonly generatePaymentMethodClientToken: {
    readonly __typename: "GeneratePaymentMethodClientTokenSuccess";
    readonly token: string | null;
    readonly url: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type useBraintreeClientTokenMutation = {
  response: useBraintreeClientTokenMutation$data;
  variables: useBraintreeClientTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "generatePaymentMethodClientToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "token",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          }
        ],
        "type": "GeneratePaymentMethodClientTokenSuccess",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useBraintreeClientTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useBraintreeClientTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d2569cd108e58c197323ae7fa75bbcc0",
    "id": null,
    "metadata": {},
    "name": "useBraintreeClientTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useBraintreeClientTokenMutation(\n  $input: GeneratePaymentMethodClientTokenInput!\n) {\n  generatePaymentMethodClientToken(input: $input) {\n    __typename\n    ... on GeneratePaymentMethodClientTokenSuccess {\n      token\n      url\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "320a486eab4218d0998bc2c0b890b692";

export default node;
